export default __webpack_public_path__ + "static/media/amex.eca22da5.svg";